// extracted by mini-css-extract-plugin
module.exports = {"arrowOpen":"styles_arrowOpen__a6_4j","arrow":"styles_arrow__Umxym"};